<template>

    <b-container>

      <div class="mt-4 d-flex burger-spacing justify-content-between">
        <back-arrow :title="$t('Add') + ' ' + $t('a')  + ' ' +  $t('projectType')"/>
      </div>

      <div class="row mt-4">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">
            <b-form @submit.stop.prevent="onSubmit">

              <div class="row">

                <!-- nom -->
                <div class="col-md-6">
                  <string-field
                    :label="$t('projectType.Name') + $t('field.mandatory')"
                    :id="'name-input'"
                    :input-value="this.form.name"
                    v-model="this.form.name"
                    :is-required="true">
                  </string-field>
                </div>

              </div>

              <div class="d-flex justify-content-end">
                <b-button type="submit" variant="secondary">{{ $t('Validate') }}</b-button>
              </div>

            </b-form>
          </b-card>
        </div>
      </div>

    </b-container>

</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import StringField from "../../components/b122/editFields/StringField.vue";

export default {

  name: 'ProjectTypeCreate',

  components: {
    StringField,
    BackArrow
  },

  data () {
    return {
      form: {
        name:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      }
    }
  },

  methods: {

    onSubmit () {

      let data = new FormData()
      data.append('name', this.form.name.value)

      api({
        method: 'POST',
        url: `projectType`,
        data: data
      })
        .then(() => {
          this.$router.push({
            name: 'ProjectTypeIndex'
          }, () => {
            this.$nextTick(() => {
              this.successToast(this.form.name.value)
            })
          })
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'ProjectTypeIndex',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    removeInvalidFeedback (field) {
      this.form[field]['state'] = null
    },

    successToast (name) {
      this.$bvToast.toast(this.$i18n.t('projectType') + ' "' + name + '" ' + this.$i18n.t('added'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/projectType/ProjectTypeCreate.vue